export function hasHTMLTags(str: string) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
